import * as React from "react";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { Hero } from "../components/Hero";
import { Highlights } from "../components/Highlights";
import { Pricing } from "../components/Pricing";
import { Services } from "../components/Services";
import { FAQ } from "../components/FAQ";
import { Wrapper } from "../layout/Wrapper";
import { AboutUs } from "../components/AboutUs";

const Homepage = ({ mode, toggleColorMode }) => {
  return (
    <Wrapper mode={mode} toggleColorMode={toggleColorMode}>
      <Hero />
      <Box sx={{ bgcolor: "background.default" }}>
        <AboutUs />
        <Services />
        <Divider />
        <Highlights />
        <Divider />
        <Pricing />
        <Divider />
        <FAQ />
        {/* <ContactComponent
          navigatelink={"/book-a-call"}
          btnLabel={"Let's Talk"}
          titleLable={"Lets talk about your vision and bring it to the life"}
        /> */}
      </Box>
      <Divider />
    </Wrapper>
  );
};

export default Homepage;
